var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticStyle:{"width":"0","height":"0"},attrs:{"autofocus":"","autocomplete":"off","hide-details":""},on:{"focus":function($event){return _vm.$emit('focus')}}})}
var staticRenderFns = []

export { render, staticRenderFns }